<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/spain/ribera-del-duero')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/spain/ribera-del-duero/pingus')">Pingus
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/spain/ribera-del-duero/vega-sicilia')">Vega Sicilia
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back"
                                   :to="localePath('/wine-guide/spain/ribera-del-duero')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Vega Sicilia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Conosciuto per le sue proporzioni leggendarie e il potenziale di invecchiamento quasi illimitato, Vega Sicilia è il buon vino spagnolo che gli investitori vogliono ottenere. Bar Pingus, è l'unico vino spagnolo che ha un valore reale per un investitore, ma ragazzo oh ragazzo, ciò che al paese potrebbe mancare in quantità, Vega Sicilia è più che compensato dalla qualità.
                    </div>

                    <div class="howto-title2">Alvarez in soccorso</div>
                    <div class="howto-text">
                        Anche se un velo di mistero avvolge il suo nome (no, non ha niente a che fare con la Sicilia ma
                        tradotto letteralmente significa campo di Cecilia), non c'è nulla di segreto in Vega Sicilia.
                        Una volta quasi di proprietà di Julio Iglesias, il crooner spagnolo è stato battuto sul palo dal miliardario
                        l'industriale David Alvarez per l'acquisto di Vega Sicilia nel 1982. Il figlio di David, Pablo, oggi corre
                        lo spettacolo anche se si dice che i problemi familiari potrebbero vedere Alvarez junior dimettersi.
                    </div>

                    <div class="howto-title2">Il più grande desiderio della famiglia Alvarez? Per far tornare grande Vega Sicilia
                    </div>
                    <div class="howto-text">
                        Quella che un tempo era una tenuta nobiliare nel XIX secolo era purtroppo caduta in rovina quando
                        Alvarez ha acquistato Vega Sicilia. Erano finite le 500.000 viti che erano state piantate e avevano
                        ha prodotto frutti prolifici (principalmente varietà bordolesi, tra cui Pinot Noir, Cabernet Sauvignon,
                        Carmenere, Petit Verdot e Malbec ma anche Tempranillo e Garnacha). Tuttavia, come mal gestito
                        la tenuta era stata alla fine del 19° e all'inizio del 20° secolo aveva prodotto alcuni eccezionali
                        vino, il suo terroir era ancora molto, molto buono e la sua reputazione era ancora (più o meno) intatta.
                        Alvarez ha semplicemente puntato i riflettori su ciò che gli investitori di vino intelligenti sapevano da anni:
                        Unico.
                    </div>

                    <div class="howto-title2">Un lungo invecchiamento significa prezzi epici</div>
                    <div class="howto-text">
                        La tenuta produce tre vini, il leggendario Unico ma anche Valbuena e Reserva Especial.
                        Anche se non c'è dubbio che Unico sia la grande dame del dominio in cui è prodotto solo
                        anni eccezionali, e il suo invecchiamento molto, molto lungo significa che gli investitori impazienti spesso perdono
                        interesse. Valbueno è qualcosa di simile alla sorellina birichina di Unico. È prodotto da
                        vitigni più giovani e viene rilasciato prima, ma manca dell'opulenza in forte espansione di Unico (che, secondo
                        per molti, in realtà è una buona cosa). Reserva Especial è composto da una miscela di annate e can
                        includono vini fino a 35 anni. Nessuno dei tre vini è particolarmente economico. Rilascio del 2019
                        prezzi dell'annata 2009 di Unico (98 punti) a dicembre 2018 a quasi 3.000 euro a cassa
                        già visto un aumento significativo meno di sei mesi dopo. L'annata 2017 è attualmente
                        in cima alle classifiche a oltre € 1.500 (e mantenendo il suo valore).
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Vega Sicilia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Vega Sicilia ist bekannt für seine legendären Ausmaße und sein nahezu grenzenloses Alterungspotenzial und der spanische Edelwein, den Investoren kaufen möchten. Bar Pingus, es ist Spaniens einziger Wein, der für einen Investor einen echten Wert hat, aber Junge, Junge, was dem Land an Quantität fehlen könnte, macht Vega Sicilia durch Qualität mehr als wett.
                    </div>

                    <div class="howto-title2">Alvarez zur Rettung</div>
                    <div class="howto-text">
                        Obwohl sein Name von einem Schleier des Geheimnisses umgeben ist (nein, er hat nichts mit Sizilien zu tun, sondern
                        wörtlich übersetzt bedeutet es „Cecilias Feld“). An Vega Sicilia ist nichts Geheimnisvolles.
                        Der spanische Schlagersänger, der einst fast im Besitz von Julio Iglesias war, wurde von einem Milliardär überholt
                        Industrieller David Alvarez für den Kauf von Vega Sicilia im Jahr 1982. Davids Sohn Pablo leitet heute
                        obwohl Gerüchte besagen, dass familiäre Probleme dazu führen könnten, dass Alvarez junior zurücktritt.
                    </div>

                    <div class="howto-title2">Der größte Wunsch der Familie Alvarez? Um Vega Sicilia wieder großartig zu machen
                    </div>
                    <div class="howto-text">
                        Was im 19. Jahrhundert einst ein Adelssitz war, verfiel damals leider
                        Alvarez kaufte Vega Sicilia. Vorbei waren die 500.000 Weinreben, die gepflanzt worden waren und waren
                        brachte reiche Früchte (hauptsächlich Bordeaux-Sorten, darunter Pinot Noir, Cabernet Sauvignon,
                        Carmenere, Petit Verdot und Malbec, aber auch Tempranillo und Garnacha). Allerdings als schlecht gemanagt
                        Das Anwesen befand sich im späten 19. und frühen 20. Jahrhundert und hatte einige Außergewöhnliches hervorgebracht
                        Wein, sein Terroir war immer noch sehr, sehr gut und sein Ruf war noch (mehr oder weniger) intakt.
                        Alvarez warf einfach das Schlaglicht auf das, was kluge Weininvestoren seit Jahren wussten:
                        Unico.
                    </div>

                    <div class="howto-title2">Lange Reifung bedeutet epische Preise</div>
                    <div class="howto-text">
                        Das Weingut produziert drei Weine, den sagenumwobenen Unico, aber auch Valbuena und Reserva Especial.
                        Obwohl es keinen Zweifel daran gibt, dass Unico die Grande Dame des Gebiets ist, in dem es nur hergestellt wird
                        außergewöhnliche Jahre, und seine sehr, sehr lange Alterung führt dazu, dass ungeduldige Anleger oft verlieren
                        Interesse. Valbueno ist so etwas wie Unicos freche kleine Schwester. Es wird hergestellt aus
                        jüngere Reben und wird früher freigegeben, es fehlt jedoch die boomende Opulenz von Unico (die laut
                        (für viele ist das eigentlich eine gute Sache). Reserva Especial wird aus einer Mischung von Jahrgängen und Dosen hergestellt
                        Dazu gehören Weine, die bis zu 35 Jahre alt sind. Keiner der drei Weine ist besonders günstig. Veröffentlichung 2019
                        Die Preise für den Jahrgang 2009 von Unico (98 Punkte) lagen im Dezember 2018 bei knapp 3.000 € pro Kiste
                        Bereits weniger als sechs Monate später war ein deutlicher Anstieg zu verzeichnen. Der Jahrgang 2017 ist aktuell
                        Mit über 1.500 € an der Spitze der Charts (und seinen Wert halten).
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Vega Sicilia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Connu pour ses proportions légendaires et son potentiel de vieillissement presque illimité, Vega Sicilia est le vin fin espagnol que les investisseurs veulent obtenir. Bar Pingus, c'est le seul vin d'Espagne qui a une réelle valeur pour un investisseur, mais bon sang, ce que le pays pourrait manquer en quantité, Vega Sicilia fait plus que compenser en qualité.
                    </div>

                    <div class="howto-title2">Alvarez à la rescousse</div>
                    <div class="howto-text">
                        Bien qu'un linceul de mystère entoure son nom (non, cela n'a rien à voir avec la Sicile mais
                        littéralement traduit cela signifie le champ de Cecilia), il n'y a rien de secret à propos de Vega Sicilia.
                        Autrefois presque propriété de Julio Iglesias, le crooner espagnol a été coiffé au poste par le milliardaire
                        l'industriel David Alvarez pour l'achat de Vega Sicilia en 1982. Le fils de David, Pablo, dirige aujourd'hui
                        le spectacle bien que la rumeur dit que des problèmes familiaux pourraient voir Alvarez junior démissionner.
                    </div>

                    <div class="howto-title2">Le plus grand désir de la famille Alvarez ? Rendre Vega Sicilia encore plus belle
                    </div>
                    <div class="howto-text">
                        Ce qui était autrefois un domaine noble au XIXe siècle était malheureusement tombé en ruine lorsque
                        Alvarez a acheté Vega Sicilia. Finies les 500 000 vignes qui avaient été plantées et avaient
                        produit des fruits prolifiques (principalement des cépages bordelais, dont le pinot noir, le cabernet sauvignon,
                        Carménère, Petit Verdot et Malbec mais aussi Tempranillo et Garnacha). Cependant, comme mal géré
                        le domaine avait été à la fin du 19 ème et au début du 20 ème siècle il avait produit des produits exceptionnels
                        vin, son terroir était encore très, très bon et sa réputation était encore (plus ou moins) intacte.
                        Alvarez a simplement mis en lumière ce que les investisseurs en vin intelligents savaient depuis des années :
                        Unico.
                    </div>

                    <div class="howto-title2">Un long vieillissement signifie des prix épiques</div>
                    <div class="howto-text">
                        Le domaine produit trois vins, le légendaire Unico mais aussi Valbuena et Reserva Especial.
                        S'il ne fait aucun doute qu'Unico est la grande dame du domaine, elle n'est produite qu'en
                        années exceptionnelles, et son vieillissement très, très, long fait souvent perdre aux investisseurs impatients
                        intérêt. Valbueno ressemble à la petite sœur coquine d'Unico. Il est produit à partir
                        jeunes vignes et est libéré plus tôt, mais manque à l'opulence en plein essor d'Unico (qui, selon
                        pour beaucoup, est en fait une bonne chose). Reserva Especial est élaboré à partir d'un mélange de millésimes et peut
                        inclure des vins jusqu'à 35 ans. Aucun des trois vins n'est particulièrement bon marché. sortie 2019
                        prix du millésime 2009 d'Unico (98 points) en décembre 2018 à près de 3 000 € la caisse avait
                        déjà connu une hausse significative moins de six mois plus tard. Le millésime 2017 est actuellement
                        en tête des charts à plus de 1 500 € (et en maintenant sa valeur).
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Vega Sicilia</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Known for its legendary proportions and almost limitless ageing potential Vega Sicilia is the Spanish fine wine that investors want to get. Bar Pingus, it is Spain’s only wine that has any real value to an investor, but boy oh boy, what the country might lack in quantity, Vega Sicilia more than make up for in quality.
                    </div>

                    <div class="howto-title2">Alvarez to the rescue</div>
                    <div class="howto-text">
                        Although a shroud of mystery surrounds its name (no, it has nothing to do with Sicily but
                        literally translated it means Cecilia’s field), there is nothing secretive about Vega Sicilia.
                        Once almost owned by Julio Iglesias, the Spanish crooner was pipped at the post by billionaire
                        industrialist David Alvarez for Vega Sicilia’s purchase in 1982. David’s son Pablo today runs
                        the show although rumour has it that family issues could see Alvarez junior step down.
                    </div>

                    <div class="howto-title2">The Alvarez family’s greatest desire? To make Vega Sicilia great again
                    </div>
                    <div class="howto-text">
                        What has once been a noble estate in the 19th century had sadly fallen into disrepair when
                        Alvarez purchased Vega Sicilia. Gone were the 500,000 vines that had been planted and had
                        yielded prolific fruit (mostly Bordeaux varieties, including Pinot Noir, Cabernet Sauvignon,
                        Carmenere, Petit Verdot and Malbec but also Tempranillo and Garnacha). However, as mismanaged
                        the estate had been in the late 19 th and early 20 th century it had produced some exceptional
                        wine, its terroir was still very, very good and its reputation was still (more or less) intact.
                        Alvarez simply threw the spotlight on what clever wine investors had known about for years:
                        Unico.
                    </div>

                    <div class="howto-title2">Long ageing means epic prices</div>
                    <div class="howto-text">
                        The estate produces three wines, the fabled Unico but also Valbuena and Reserva Especial.
                        Although there is no doubt that Unico is the grande dame of the domain it is only produced in
                        exceptional years, and its very, very, long ageing means impatient investors often lose
                        interest. Valbueno is something akin to Unico’s naughty little sister. It is produced from
                        younger vines and is released earlier, but lacks to booming opulence of Unico (which, according
                        to many, is actually a good thing). Reserva Especial is made from a blend of vintages and can
                        include wines up to 35 years old. None of the three wines is especially cheap. 2019s release
                        prices of the 2009 vintage of Unico (98 points) in December 2018 at almost €3,000 a case had
                        already seen a significant rise less than six months later. The 2017 vintage is currently
                        topping the charts at over €1,500 (and holding its value).
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VegaSicilia",
    head: {
        title: 'Vega Sicilia | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional quality and rich tradition of Vega Sicilia, a world-renowned wine producer located in the Ribera del Duero region of Spain. Savor their outstanding and innovative blends, crafted with passion and expertise.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Vega Sicilia', src: '/wine-guide/spain/ribera-del-duero/vega-sicilia'},
            items: [
                {report: 'Pingus', src: '/wine-guide/spain/ribera-del-duero/pingus'},
                {report: 'Vega Sicilia', src: '/wine-guide/spain/ribera-del-duero/vega-sicilia'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
